import { Theme, withStyles } from '@material-ui/core';
import { createStyles, WithStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { Link } from '@material-ui/icons';
import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import MyButton from '../../components/UI/MyButton/MyButton';
import MyTooltip from '../../components/UI/MyTooltip/MyTooltip';
import { IFeed, IPlaylist } from '../../models/states';
import { LightenDarkenColor, SKYNET_STATES } from '../../utilities/utilities';
import {
  Actions,
  Customer,
  FeedName,
  HeadendStatus,
  LastPublishedPlaylistId,
  LatestPlaylistStatus,
  MissingAssetsOnCloud,
  // MissingHeadendStatus,
  PlaylistDate,
  PlaylistValidation,
  SrNo
} from './Columns';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      cursor: 'pointer',
      ...theme.tableRow
    },
    customer: {
      maxWidth: '30ch',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 500
    },
    failedState: {
      backgroundColor: theme.tertiaryColors.red,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.red,
          40
        )} !important`
      }
    },
    warning: {
      backgroundColor: theme.tertiaryColors.orange,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.orange,
          40
        )} !important`
      }
    },
    escalated: {
      backgroundColor: theme.tertiaryColors.pink,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.pink,
          40
        )} !important`
      }
    },
    blackBackground: {
      // background: theme.palette.background.default
    },
    actionBtn: {
      fontSize: '0.75rem',
      width: '6rem'
      // zIndex: 100
    },
    link: {
      textDecoration: 'none',
      display: 'flex',
      marginLeft: '0.5rem',
      color: theme.palette.text.primary
    },
    blur: {
      filter: 'blur(5px)'
    }
  });

class PlaylistPodTableItem extends React.Component<IPlaylistPodTableItem> {
  public render() {
    const { item, index, classes, click } = this.props;
    let missingAssetsCloud = 0;
    let missingAssetsHeadends = 0;
    if (item.last_published && item.last_published.missing_list) {
      if (item.last_published.missing_list.cloud) {
        for (const assetType of Object.keys(
          item.last_published.missing_list.cloud
        )) {
          missingAssetsCloud +=
            item.last_published.missing_list.cloud[assetType].length;
        }
      }
      if (item.last_published.missing_list.headends) {
        for (const assetType of Object.keys(
          item.last_published.missing_list.headends
        )) {
          missingAssetsHeadends +=
            item.last_published.missing_list.headends[assetType].length;
        }
      }
    }
    let latestPlaylistId = 'NA';
    if (item.last_unpublished) {
      latestPlaylistId = item.last_unpublished.version;
    } else if (item.last_published) {
      latestPlaylistId = item.last_published.version;
    }

    const blur = globalThis.UI_CONFIG.blur_data ? true : false;

    return (
      <TableRow
        key={index}
        className={classnames(classes.root, {
          [classes.failedState]: item.skynet_status === SKYNET_STATES.FAILED,
          [classes.warning]:
            item.skynet_status === SKYNET_STATES.WARNING ||
            item.skynet_status === SKYNET_STATES.SLA_VIOLATED,
          [classes.escalated]: item.action === 'escalated'
        })}
        hover
        onClick={click}
      >
        <SrNo>
          <Typography variant={'caption'}>{item.sr_no}</Typography>
        </SrNo>
        <Customer>
          <MyTooltip title={item.customer} blur={blur}>
            <Typography
              className={classnames(classes.customer, { [classes.blur]: blur })}
              variant={'caption'}
            >
              {item.customer}
            </Typography>
          </MyTooltip>
        </Customer>
        <FeedName>
          <MyTooltip title={item.feed_name} blur={blur}>
            <Typography
              variant={'caption'}
              className={classnames({ [classes.blur]: blur })}
            >
              {item.feed_name}
            </Typography>
          </MyTooltip>
        </FeedName>
        <PlaylistDate>
          <MyTooltip title={item.play_on}>
            <Typography variant={'caption'}>{item.play_on}</Typography>
          </MyTooltip>
        </PlaylistDate>
        <LastPublishedPlaylistId>
          <Typography variant={'caption'}>
            {item.last_published ? item.last_published.version : 'NA'}
          </Typography>
        </LastPublishedPlaylistId>
        <MissingAssetsOnCloud>
          <Typography
            variant={'caption'}
          >{`${missingAssetsCloud}/${missingAssetsHeadends}`}</Typography>
        </MissingAssetsOnCloud>
        <HeadendStatus>
          <Typography variant={'caption'}>
            {item.last_published
              ? item.last_published.headends_download_status
              : 'NA'}
          </Typography>
        </HeadendStatus>

        <LatestPlaylistStatus>
          <Typography variant={'caption'}>{latestPlaylistId}</Typography>
        </LatestPlaylistStatus>
        <PlaylistValidation>
          <MyTooltip
            title={
              item.skynet_status === SKYNET_STATES.SNOOZED
                ? `Activate at ${moment
                    .unix(item.end_snooze_at)
                    .format('YYYY-MM-DD HH:mm:ss')}`
                : item.skynet_message
            }
          >
            <Typography variant={'caption'}>{item.skynet_status}</Typography>
          </MyTooltip>
        </PlaylistValidation>
        {globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.disable_issue_tracker ? null : (
          <Actions>
            {item.issue_tracker_ticket && item.issue_tracker_ticket.issue_id ? (
              <a
                href={`${globalThis.UI_CONFIG.issue_tracker_url}/${item.issue_tracker_ticket.issue_id}`}
                target="_blank"
                className={classes.link}
              >
                <Typography onClick={e => e.stopPropagation()}>
                  {item.issue_tracker_ticket.issue_id}
                </Typography>
                <Link style={{ paddingBottom: 5 }} />
              </a>
            ) : (
              <MyButton
                onClick={e => {
                  e.stopPropagation();
                  this.props.onEscalate(e);
                }}
                btnType="pink"
                className={classes.actionBtn}
              >
                Escalate
              </MyButton>
            )}
          </Actions>
        )}
      </TableRow>
    );
  }
}
export interface IPlaylistPodTableItemOwnProp
  extends WithStyles<typeof styles> {
  item: IPlaylist;
  index: number;
  feedMap: { [key: string]: IFeed };
  key: number;
  click: () => any;
  onEscalate: (e: any) => any;
}
type IPlaylistPodTableItem = IPlaylistPodTableItemOwnProp;

export default withStyles(styles)(PlaylistPodTableItem);
